import TraceChart from './TraceChart';

export default TraceChart;
